import { render, staticRenderFns } from "./StarredMessageBalloon.vue?vue&type=template&id=8aa61168&scoped=true&"
import script from "./StarredMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./StarredMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./StarredMessageBalloon.vue?vue&type=style&index=0&id=8aa61168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa61168",
  null
  
)

export default component.exports